import counterUp from 'counterup2'

// var $ = jQuery;
// var once_wave = 0;

export default function (that) {
    const counterElement = that.find('.countup');

    counterElement.each(function (idx, el) {
        counterUp(el, {
            duration: 1000,//1200,
            delay: 50,
        })
    });

};